// extracted by mini-css-extract-plugin
export default {"container":"UsersAssignedFilter_container__wgLqX","label":"UsersAssignedFilter_label__obt8B","options":"UsersAssignedFilter_options__TuAk5"};